<template>
<v-window v-model="step" >
  <!-- <v-window-item >
    <v-card class="grey lighten-4" >
      <v-card-title>Create a new space or location
        <v-spacer/>
        <v-btn text samll href="https://help.appointmentguru.co/what-is-a-space.html" target="_blank" >Learn more <v-icon small class="ml-2" >mdi-open-in-new</v-icon></v-btn>
      </v-card-title>
      <v-card-text >
        <v-row >
          <v-col cols="12" >
            <v-card class="elevation-5" >
              <v-card-title class="py-1 grey lighten-4" >
                <v-icon class="mr-3" color="primary" >mdi-office-building-plus-outline</v-icon>
                New Space
                <v-spacer/>
                <v-btn @click="step++" small class="primary" style="width:180px;" >
                  Create space
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-card-title>
              <v-divider/>

              <v-card-text >
                <ul>
                  <li>A space is like a business. With AppointmentGuru you can create multiple spaces in your account. </li>
                  <li>Create a new space if you need different branding, banking and invoice deails.</li>
                  <li>If you only need to add a new address to your business, consider rather adding a location</li>
                </ul>
              </v-card-text>

            </v-card>
          </v-col>

          <v-col cols="12" >
            <v-card class="elevation-5" >
              <v-card-title class="py-1 grey lighten-4" >
                <v-icon class="mr-3" color="primary" >mdi-map-marker-radius-outline</v-icon>
                New Location
                <v-spacer/>
                <v-btn small class="primary" style="width:180px;" >Create Location
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-card-title>
              <v-divider/>
              <v-card-text >
                <ul>
                  <li>Add an address to an existing business.</li>
                  <li>Use this if you have a single business that operates out of more than one location.</li>
                  <li>A location will have it's own operating bours per practitioner, and you can assign appointment types in your space to this location.</li>
                </ul>
              </v-card-text>
            </v-card>
          </v-col>

        </v-row>
      </v-card-text>

    </v-card>
  </v-window-item> -->

  <!-- Create space -->
  <v-window-item >
    <v-card >
      <request-status :request="req" @ok="setSpace" />
      <v-card-title>Give your new space a name</v-card-title>
      <v-card-text>
        <v-text-field filled autofocus persistent-hint
            v-model='title'
            label='What is the name of your business?'
            append-icon='mdi-arrow-right'
            @keypress.enter="createspace"
            @click:append='createspace' />

      </v-card-text>
      <v-card-actions >
        <v-btn text >Learn more</v-btn>
        <v-spacer/>
        <v-btn color="primary"
          :disabled="!title"
          @click="createspace" >Create space</v-btn>
      </v-card-actions>
    </v-card>
  </v-window-item>

  <!-- Edit -->
  <v-window-item >
    <space
      v-if="spaceId"
      :user="me"
      v-model="space"
      @done="step++" />
  </v-window-item>

  <!-- Success -->
  <v-window-item >
    <v-card>
      <v-card-text class="text-center">
        <v-icon :size="75" color="success" >mdi-check-circle</v-icon><br/>
        <h2 class="mt-3">Successfully created space</h2>
      </v-card-text>
      <v-card-actions >
        <v-btn text
          @click="$emit('close')" >Done</v-btn>
        <v-spacer />
        <v-btn color="primary"
          @click="$emit('close')"
          :to="`/settings/spaces/${spaceId}`" >
          Continue editing space
          <v-icon small class="ml-2">mdi-arrow-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-window-item>
</v-window>
</template>

<script>
import Space from './Space.vue'
import {mapGetters} from 'vuex'

const STEPS = {
  INIT: 0,
  EDIT: 1,
  SUCCESS: 2
}

export default {
  name: 'SpaceWizard',
  components: {Space},
  props: {
    value: { type: Object },
    touch: { type: Number, default: 0 }
  },
  data () {
    return {
      step: 0,
      STEPS: STEPS,
      title: null,
      req: {
        resource: 'ag.spaces'
      },
      space: {}
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value && this.value.id) {
          this.space = this.value
          this.step = STEPS.EDIT
        }
      }
    },
    touch () {
      this.reset()
    }
  },
  computed: {
    ...mapGetters('identity', ['me']),
    spaceId () {
      if (this.space) { return this.space.id }
      return null
    }
  },
  methods: {
    reset () {
      this.step = STEPS.INIT
      this.title = ''
      this.space = {}
    },
    createspace () {
      if (!this.title) { return null }
      this.req.data = {
        title: this.title
      }
      this.$request('save', this.req)
    },
    setSpace (data) {
      console.log(data)
      this.space = data.result
      this.step++
    }
  }
}
</script>
